import nomad_amico from "../assets/images/nomad-amico.png";

const about = {
  photo: nomad_amico,
  title: "About Me",
  description:
    "I am a self-taught Full Stack Developer. A multi-skilled Full Stack Developer with hands-on experience in problem solving and creating web features, passionate about exploring on new stacks with the ability to learn fast from peoples experience.",
  description_sub_title: "I've developed extensive knowledge in",
};

const lists = [
  "FRONT END DEVELOPMENT:  React",
  "BACK END DEVELOPMENT:  Node | Ruby on Rails",
  "DATABASE:  Postgres",
  "DESIGN:  Styled-components | SCSS | CSS-in-JS | Bootstrap",
  "PRODUCT MANAGEMENT:  UI design | Prototyping | Wireframing",
  "INFRA:  Heroku | Netlify",
];

export { about, lists };
